import { executePdfOperation } from '../../harness/pdf-tools-bridge';
import { buildPdfOperationContext } from '../../contexts/pdf-context';

export async function executePdfFanOut(prompt: string, pdfAttachments: any[]): Promise<string> {
    if (!pdfAttachments || pdfAttachments.length === 0) {
        return "";
    }

    try {
        const result = await executePdfOperation(prompt, pdfAttachments, (msg) => {
            console.log("[PDF-Tools Fan-Out Progress]:", msg);
        });

        if (result) {
            return buildPdfOperationContext(result);
        }
    } catch (e) {
        console.error("PDF-Tools Fan-Out execution failed", e);
    }
    
    return "";
}
